import { Route, Routes, Navigate } from "react-router-dom";
import Login from "../pages/Login";

const Unauthenticated = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate replace to="/login" />} />
      <Route path="/login" element={<Login />} />
    </Routes>
  );
};
export default Unauthenticated;
